import React from 'react';
import {ObservableMap, observable} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {SEVERITY, ValidationMessage} from "core/common/domain/commonDomain";
import {EntityStatus} from "core/event/eventDomain";
import uiService from "core/common/service/uiService";
import LinearProgress from "material-ui/LinearProgress";



export interface DialogProps {
  entities?: ObservableMap<MdEntity>;
}


const __progressBarStyleOverride = {
  height: 2,
  width: "100%",
  backgroundColor: "white"
};


export class DialogAncestor<P, S, R> extends React.Component<P,S> {

  protected resolve: (value?: R | PromiseLike<R>) => void;
  protected reject: (reason?: any) => void;
  @observable protected dialogOpen: boolean = false;
  @observable protected $errors: ValidationMessage[];


  public hasErrors(): boolean {
    return this.$errors && this.$errors.length > 0;
  }

  public titleWithProgress(titleStr: string) {
    return (
      <div>
        <div>{titleStr}</div>
        { (uiService.getDialogActionFlag()) ? <LinearProgress mode="indeterminate" style={__progressBarStyleOverride} /> : <div style={__progressBarStyleOverride}/>}
      </div>
    );
  }


}

export class SteppingDialogAncestor<P, S, R> extends DialogAncestor<P,S,R> {


}




export function entityStatusCss(entityStatus: EntityStatus): string {
  return (entityStatus.status === SEVERITY.ERROR) ?  "color-red-500" :
    ( (entityStatus.status === SEVERITY.WARNING) ? "color-amber-600" :
        ( (entityStatus.status === SEVERITY.NOOP) ? "color-grey-500" : "color-green-500" )
    );
}

export function  entityStatusText(entityStatus: EntityStatus): string {
  return (!entityStatus.status || entityStatus.status === SEVERITY.INFO) ?  "OK" :
    ( (entityStatus.status === SEVERITY.NOOP) ? "UNMODIFIED" : entityStatus.status );
}


export function  validationMessageCss(validationMessage: ValidationMessage): string {
  return (validationMessage.severity === SEVERITY.ERROR) ?  "color-red-500" :
    ( (validationMessage.severity === SEVERITY.WARNING) ? "color-amber-600" :
      ( (validationMessage.severity === SEVERITY.INFO) ? "color-blue-500" : null) );
}



// WEBPACK FOOTER //
// ./src/core/common/page/dialogAncestor.tsx